import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
  FaFacebook, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedin 
} from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';
import { sharedTranslations } from '../translations/shared';
import '../App.css';

function Footer() {
  const location = useLocation();
  const { language } = useLanguage();
  const t = sharedTranslations[language] || sharedTranslations.en;

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    
    // If we're not on the home page, navigate to home first
    if (location.pathname !== '/') {
      window.location.href = `/${targetId}`;
      return;
    }
    
    const element = document.querySelector(targetId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer id="contact" className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <h3 className="footer-logo">
              <span className="logo-icon">🏆</span>
              {t.footer.championMaker}
            </h3>
            <p className="footer-description">{t.footer.description}</p>
            <div className="social-icons">
              <a href="#" aria-label="Facebook"><FaFacebook /></a>
              <a href="#" aria-label="Twitter"><FaTwitter /></a>
              <a href="#" aria-label="Instagram"><FaInstagram /></a>
              <a href="#" aria-label="LinkedIn"><FaLinkedin /></a>
            </div>
          </div>
          
          <div className="footer-column">
            <h4>{t.footer.links}</h4>
            <ul>
              <li><Link to="/about">{t.footer.aboutUs}</Link></li>
              <li><Link to="/packages">{t.footer.ourPackages}</Link></li>
              <li><Link to="/locations">{t.footer.locations}</Link></li>
              <li><Link to="/contact">{t.footer.contact}</Link></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4>{t.footer.packagesAndLocations}</h4>
            <ul>
              <li><Link to="/locations/kranevo">{t.footer.kranevo}</Link></li>
              <li><Link to="/locations/plovdiv">{t.footer.plovdiv}</Link></li>
              <li><Link to="/locations/sofia-boyana">{t.footer.sofiaBoyana}</Link></li>
              <li><Link to="/locations/sofia-mladost">{t.footer.sofiaMladost}</Link></li>
              <li><Link to="/locations/sofia-nsa">{t.footer.sofiaNsa}</Link></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4>{t.footer.contact}</h4>
            <ul className="contact-info">
              <li>
                <FaMapMarkerAlt /> {t.footer.address}
              </li>
              <li>
                <FaEnvelope /> <a href="mailto:info@championmaker.org">info@championmaker.org</a>
              </li>
              <li>
                <FaPhone /> <a href="tel:+359885740431">+359 885740431</a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>{t.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
